/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License.
 */

import { LogLevel } from '@azure/msal-browser';

/**
 * Configuration object to be passed to MSAL instance on creation.
 * For a full list of MSAL.js configuration parameters, visit:
 * https://github.com/AzureAD/microsoft-authentication-library-for-js/blob/dev/lib/msal-browser/docs/configuration.md
 */
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_AD_TENNANT_ID}`,
    redirectUri: '/',
  },
  cache: {
    cacheLocation: 'localStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            process.env.REACT_APP_DEBUG_ON === 'true' && console.error(message);
            return;
          case LogLevel.Info:
            process.env.REACT_APP_DEBUG_ON === 'true' && console.info(message);
            return;
          case LogLevel.Verbose:
            process.env.REACT_APP_DEBUG_ON === 'true' && console.debug(message);
            return;
          case LogLevel.Warning:
            process.env.REACT_APP_DEBUG_ON === 'true' && console.warn(message);
            return;
          default:
            return;
        }
      },
    },
  },
};
